module.exports = __webpack_public_path__ + "img/電気回路_2_6_5.e0939ea5.png";